import { listCompanySummaryData } from "./api/underwritingApi";
import countryMapping from './utils/countries';

export const safeJSONParse = (data) => {
  try {
    if (typeof data === "object") return data;
    let parsed = data;
    while (typeof parsed === "string") {
      try {
        parsed = JSON.parse(parsed);
      } catch {
        break;
      }
    }
    return parsed;
  } catch (error) {
    console.error("Error parsing JSON:", error);
    return null;
  }
};

export const checkCompanies = async (data, tenantId) => {
  console.log("checkCompanies",data)
  const companiesToCheck = [
    ...(data?.parent_company?.name ? [data?.parent_company] : []),
    ...(data?.subsidiaries || []),
    ...(data?.related_companies || []),
    ...(data?.competitors || [])
  ];

  if (companiesToCheck.length === 0) return {};
  console.log("companiesToCheck",companiesToCheck)
  try {
    const allCompanies = await listCompanySummaryData(tenantId);
    
    const results = {};
    for (const company of companiesToCheck) {
      
      const matchingCompany = allCompanies.find(c => 
        c.companyName.toLowerCase() === company.name.toLowerCase()
      );

      if (matchingCompany) {
        const summaryData = JSON.parse(matchingCompany.summaryData);
        results[company.name] = { combinedScore: summaryData["Combined Score"] };
      }
    }
    
    return results;
  } catch (error) {
    console.error('Error fetching companies:', error);
    return {};
  }
};

export const getCompanyTreeData = (treeData) => {
  if(!treeData) return {
    data: treeData,
    treeNotExist: true,
    hasKeyStaff: false,
    hasParentCompany: false,
    hasSubsidiaries: false,
    hasRelatedCompanies: false,
    hasCompetitors: false,
    hasRelatedPeople: false,
  }

  // Map the response structure to what the component expects
  const mappedData = {
    keyPeople: treeData.key_staff || treeData.keyPeople || [],
    parent: treeData.parent_company || treeData.parent || {},
    subsidiaries: treeData.subsidiaries || [],
    relatedCompanies: treeData.related_companies || treeData.relatedCompanies || [],
    competitors: treeData.competitors || [],
    relatedPeople: treeData.related_people || treeData.relatedPeople || []
  };

  const hasKeyStaff =
    mappedData.keyPeople?.length > 0 &&
    mappedData.keyPeople.some((staff) => staff.full_name || staff.position);

  const hasParentCompany = Object.values(mappedData.parent || {}).some(
    (value) => value && value !== ""
  );

  const hasSubsidiaries =
    mappedData.subsidiaries?.length > 0 &&
    mappedData.subsidiaries.some(
      (sub) =>
        sub.name ||
        sub.country ||
        sub.industry ||
        sub.ownership_percentage ||
        sub.revenue ||
        sub.number_of_employees
    );

  const hasRelatedCompanies =
    mappedData.relatedCompanies?.length > 0 &&
    mappedData.relatedCompanies.some(
      (company) => company.name || company.country || company.relationship_type
    );

  const hasCompetitors =
    mappedData.competitors?.length > 0 &&
    mappedData.competitors.some((comp) => comp.name || comp.country);

  const hasRelatedPeople =
    mappedData.relatedPeople?.length > 0 &&
    mappedData.relatedPeople.some(
      (person) => person.full_name || person.relationship_type
    );

  const hasAnyData =
    hasKeyStaff ||
    hasParentCompany ||
    hasSubsidiaries ||
    hasRelatedCompanies ||
    hasCompetitors ||
    hasRelatedPeople;

  const treeNotExist = !treeData || !hasAnyData;

  return {
    data: mappedData, // Return the mapped data structure
    treeNotExist,
    hasKeyStaff,
    hasParentCompany,
    hasSubsidiaries,
    hasRelatedCompanies,
    hasCompetitors,
    hasRelatedPeople,
  };
};
